export const tagsKeys = {
	all: ['crm', 'tags'],
	list: (filters = {}) => ['crm', 'tags', 'list', filters],
};

export const tagsMutationKeys = {
	create: ['crm', 'tags', 'create'],
	rename: ['crm', 'tags', 'rename'],
	delete: ['crm', 'tags', 'delete'],
	assign: ['crm', 'tags', 'assign'],
	setCompany: ['crm', 'tags', 'setCompany'],
};
